export default __webpack_public_path__ + "static/media/8900 - TokenJuggler.e7cd5d6f.jpeg";